import { client } from "./index";
import { vendor } from "../Constant/index";


export const getProduct = (category) => client.get(`products?email=${vendor}&category=${category == 'All' ? '' :category}`);
